import React from 'react';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { kebabCase } from 'lodash';
import BoxedContainer from '../layouts/BoxedContainer';
import Button from '../layouts/Button';

export default function FullWidthCtaCard({ data }) {
  const { title, text, link, image } = data;
  return (
    <section
      className="lg:h-[615px] h-[465px] relative before:!inline before:content-['']
    before:absolute before:top-0 before:w-full before:h-full before:bg-black
    before:bg-opacity-50 clip-right-top lg:-mt-20 -mt-[20px] z-10 overflow-hidden"
    >
      {image && (
        <LazyLoadImage src={image.url} alt={title} className="w-full h-full object-cover" />
      )}
      <div className="absolute top-0 w-full h-full lg:pt-[180px] pt-[110px] pb-[250px]">
        <BoxedContainer className="h-full boxed">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.4 }}
            viewport={{ once: true }}
            className="flex flex-col lg:gap-y-[38px] gap-y-[25px] h-full justify-center
            items-center"
          >
            <div className="flex flex-col lg:gap-y-[34px] gap-y-[15px] max-w-[770px] text-center">
              <h3
                className="text-white font-roboto-condensed-bold lg:text-[38px] text-[35px]
                lg:leading-[1] leading-[45px] flex flex-col uppercase"
              >
                {title}
              </h3>
              <p
                className="text-white font-roboto-regular lg:text-[16px] text-[15px]
                lg:leading-[23px] leading-6"
              >
                {text}
              </p>
            </div>
            {link && (
              <Button
                url={link.url}
                label={link.name}
                ariaLabel={link.name}
                tagName={kebabCase(link.name)}
                variant="primaryWhite"
                text="w-[270px] px-[26px] whitespace-pre !bg-white hover:!bg-black"
              />
            )}
          </motion.div>
        </BoxedContainer>
      </div>
    </section>
  );
}
